import { makeStyles } from '@mui/styles';
import React from 'react';
import { Grid2, Typography } from '@mui/material';
import { COLORS } from '../../../utils/Application_Constants';

const useStyles = makeStyles((theme) => ({
    preview: {
        border: `1px solid ${COLORS.LT_MIDNIGHT10}`,
        padding: 12,
        borderRadius: 4,
        '&:hover': {
            cursor: 'pointer',
            background: COLORS.LT_MIDNIGHTBG1,
        },
    },
    fileThumbnail: {
        width: 40,
        height: 40,
        borderRadius: '4px',
        display: 'block',
        objectFit: 'cover',
        cursor: 'pointer',

        '&.skeleton': {
            background: COLORS.LT_MIDNIGHT25,
            animation: '$pulse 2s cubic-bezier(.4,0,.6,1) infinite',
        },
    },
    pdfThumbnail: {
        width: 40,
        height: 40,
        borderRadius: '4px',
        background: COLORS.LT_JOURNEY75,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    fileName: {
        fontWeight: 'bold',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'block',
        whiteSpace: 'nowrap',
    },
    fileNameLink: {
        '& u': {
            color: COLORS.LT_JOURNEY,
            fontWeight: 'bold',
        },
    },
    fileSize: {
        fontWeight: 'bold',
        color: COLORS.LT_MIDNIGHT50,
    },
    '@keyframes pulse': {
        '0%': {
            opacity: 1,
        },
        '50%': {
            opacity: 0.5,
        },
        '100%': {
            opacity: 1,
        },
    },
}));

const FileRejections = (props) => {
    const classes = useStyles();
    const { fileRejections } = props;

    const bytesToMegaBytes = (bytes) => (bytes / (1024 * 1024)).toFixed(1);
    const bytesToKiloBytes = (bytes) => (bytes / 1024).toFixed(1);
    console.log('FileRejections', fileRejections);
    return (
        <div className={classes.fileRejections}>
            {fileRejections.map(({ file, errors }) => (
                <Grid2
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    key={file.name}
                    className={classes.preview}
                >
                    <Grid2 item size={7}>
                        <Grid2 container alignItems="center" spacing={1}>
                            <Grid2 item size={7}>
                                <div className={classes.fileName}>
                                    <Typography
                                        className={classes.fileNameLink}
                                        variant="caption"
                                        title={file.name}
                                    >
                                        <u>{file.name}</u>
                                    </Typography>
                                </div>
                                <Typography variant="caption" className={classes.fileSize}>
                                    {bytesToMegaBytes(file.size) < 0.1
                                        ? `${bytesToKiloBytes(file.size)}KB`
                                        : `${bytesToMegaBytes(file.size)}MB`}
                                </Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                    <Grid2 item>
                        <Grid2 container alignItems="center" spacing={1}>
                            <Grid2 item size={12} className={classes.fileRejection}>
                                <b>Rejections:</b>
                                <ul>
                                    {errors.map((e) => {
                                        const message =
                                            e.code === 'file-invalid-type'
                                                ? 'Invalid file type'
                                                : e.message;
                                        return (
                                            <li title={message} key={e.code}>
                                                <span>{message}</span>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>
            ))}
        </div>
    );
};

export default FileRejections;
